import { PrimaryButton, SecondaryButton } from '@designsforhealth/dfh-react-components'
import { Grid } from '@material-ui/core'
import classnames from 'classnames'
import React, { FC, useCallback } from 'react'
import { IoIosCheckmarkCircleOutline } from 'react-icons/io'
import styled from 'styled-components'

import { publishBeginCheckoutEvent } from '../../../lib/analytics/cart'
import { useCartContext } from '../../../lib/cart'
import { publishConversionsBeginCheckout } from '../../../lib/conversions/actions'
import { useDispensaryCartStatus } from '../../../lib/dispensaries/events/cart'
import { usePageUrl } from '../../../lib/pages'

export interface CartContinueButtonsProps {
  formDisabled: boolean
  className?: string
  id?: string
}

const StyledGrid = styled(Grid)`
  flex-direction: column;
  .continueShoppingButton,
  .secureCheckoutButton {
    margin: 10px 0;
    width: 100%;
  }

  @media (min-width: 600px) {
    flex-direction: row;
    justify-content: space-between;
    gap: 24px;
  }

  button {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`

const StyledButtonContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`

export const CartContinueButtons: FC<CartContinueButtonsProps> = ({
  formDisabled,
  className,
  id,
}) => {
  const { loading } = useDispensaryCartStatus()
  const { cart } = useCartContext()
  const { navigate } = usePageUrl()

  const disabled = formDisabled || loading

  const goToShipping = useCallback(() => {
    // TODO Given that two buttons should not have the same ID we'll need to figure out how
    //    to differentiate the two Secure Checkout buttons here when we add the logging.
    // logEvent({ name: 'secure-checkout-button' })
    if (!cart) {
      return
    }
    publishBeginCheckoutEvent(cart)
    publishConversionsBeginCheckout(cart)
    navigate('/checkout/shipping/')
  }, [cart, navigate])

  return (
    <StyledGrid
      className={classnames('continueButtons', className)}
      id={id}
      container
      item
      xs={11}
      sm={12}
      justify="center"
      wrap="nowrap"
    >
      <SecondaryButton
        className="continueShoppingButton"
        disabled={disabled}
        onClick={() => navigate('/products')}
      >
        Continue Shopping
      </SecondaryButton>
      <PrimaryButton
        className="secureCheckoutButton"
        id="secure-checkout-button"
        data-cy="cart-secure-checkout-button"
        // Ensure the button is disabled during processing and also when no valid
        // items are in the cart so a user cannot complete a purchase at all:
        disabled={disabled || !cart?.items?.length}
        onClick={goToShipping}
        type="submit"
      >
        <StyledButtonContent>
          <IoIosCheckmarkCircleOutline />
          <div>Secure Checkout</div>
        </StyledButtonContent>
      </PrimaryButton>
    </StyledGrid>
  )
}
